module.exports = __webpack_public_path__ + "img/72ed08651144f4611b267245a856d686.15e255c4.png";